export default __webpack_public_path__ + "_/_/node_modules/@pf-loan-funnel/pf-refunds/lib/assets/delay-icon-41f0985482e51f5f639d99bb44e1dbc8.svg";